module.exports = __webpack_public_path__ + "static/macbook-iphone-9f3da1fdc911fccba898041af36d2b99.jpeg";